import Swiper, { EffectFade, Autoplay } from 'swiper';
Swiper.use([EffectFade, Autoplay]);

export function slider() {
  window.addEventListener('load', () => {
    if (document.querySelector('.js-slider')) {
      const swiper = new Swiper('.js-slider', {
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        autoplay: {
          delay: 3000,
        },
      });
    }
  });
}
